export default __webpack_public_path__ + "static/media/Slider4.d436dc45.jpg";